import { css } from '@emotion/react';

import IconErrorPage from '~/common/assets/images/icons/icon_error_page.svg?react';
import Flex from '~/common/components/display/Flex.tsx';
import Body from '~/common/components/typography/Body.tsx';
import Heading from '~/common/components/typography/Heading.tsx';
import EmptyLayout from '~/common/layouts/EmptyLayout.tsx';
import { APP_MODE, ViteAppMode } from '~/common/utils/env.util.ts';
import { LAYOUT } from '~/configs/theme.ts';

interface ErrorProps {
  title?: string;
  message?: string;
  status?: number;
}

const isProduction = APP_MODE === ViteAppMode.PRODUCTION;

const DEFAULT_TITLE = 'Ooops!';
const DEFAULT_MESSAGE = 'Something went wrong!';

function ErrorPage({ title, message, status }: ErrorProps) {
  const errorTitle = isProduction ? DEFAULT_TITLE : title || status || DEFAULT_TITLE;
  const errorMessage = isProduction ? DEFAULT_MESSAGE : message || DEFAULT_MESSAGE;

  return (
    <EmptyLayout>
      <Flex css={styles.errorWrapper} items="center" justify="center">
        <Flex direction="column" gap={16} items="center" justify="center">
          <IconErrorPage />
          <Heading css={styles.errorTitle}>{errorTitle}</Heading>
          <Body css={styles.errorMessage}>{errorMessage}</Body>
        </Flex>
      </Flex>
    </EmptyLayout>
  );
}

const styles = {
  errorWrapper: css`
    min-height: calc(100vh - ${LAYOUT.FOOTER_HEIGHT});
    text-align: center;
  `,

  errorTitle: css`
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: 128%;
  `,

  errorMessage: css`
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 160%;
  `,
};
export default ErrorPage;
